
import { Component, Mixins } from "vue-property-decorator";
import { NumberFormatKinds, NumberStyle } from "../../../../../../documaker/domain/format/objects";
import { INumberStylePropertyEditable, instanceOfINumberStylePropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class NumberStylePropertyEditableMixin extends Mixins() {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: INumberStylePropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: INumberStylePropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isNumberStyleEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfINumberStylePropertyEditable(s) && s.numberStyle().isEditable(), false);
  }

  get numberStyle(): NumberStyle {
    return this.readPropertyOrDefault(s => NumberStyle.from(s.numberStyle().getValue()), new NumberStyle(NumberFormatKinds.None));
  }

  set numberStyle(value: NumberStyle) {
    this.writePropertyWhenValid(s => s.numberStyle().setValue(NumberStyle.to(value)));
  }
}
